import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/socutno-zobozdravstvo.png'
import _imports_1 from '../assets/socutno-zobozdravstvo@2x.png'
import _imports_2 from '@/assets/zob.png'


const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["logo-images opacity-80", { small: _ctx.small }])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "logo",
      style: {"aspect-ratio":"1.74"},
      alt: "Sočutno Zobozdravstvo logo",
      src: _imports_0,
      srcset: _hoisted_1,
      fetchpriority: "high"
    }, null, -1),
    _createElementVNode("img", {
      style: {"aspect-ratio":"0.76"},
      class: "tooth",
      alt: "Zobek",
      src: _imports_2,
      fetchpriority: "high"
    }, null, -1)
  ]))], 2))
}